import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { FilePreviewService } from '@services/file-preview.service';

@Component({
  selector: 'app-view-file',
  templateUrl: './view-file.component.html',
  styleUrl: './view-file.component.scss',
})
export class ViewFileComponent {
  safePreviewUrl: SafeUrl | null = null;
  fileType: string | null = null;
  private objectUrl: string | null = null;
  fileName: string = 'attachment';

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private dialogRef: MatDialogRef<ViewFileComponent>,
    private filePreviewService: FilePreviewService,
    private toasterService: ToastrService,
    private sanitizer: DomSanitizer,
  ) {
    if (dialogData && dialogData.fileName) {
      this.fileName = dialogData.fileName;
    }
  }

  ngOnInit(): void {
    const fileUrl = this.dialogData.file;
    if (!fileUrl) {
      this.toasterService.error('File URL not found');
      return;
    }
    this.loadInvoicePreviewById(fileUrl);
  }

  close(): void {
    this.dialogRef.close();
  }

  download(): void {
    if (!this.objectUrl) {
      this.toasterService.error('No file to download');
      return;
    }
    const a = document.createElement('a');
    a.href = this.objectUrl;
    a.download = this.fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  loadInvoicePreviewById(fileUrl: string): void {
    this.filePreviewService.previewImage(fileUrl).subscribe({
      next: (blob) => {
        this.fileType = blob.type;
        this.objectUrl = URL.createObjectURL(blob);
        this.safePreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          this.objectUrl,
        );
      },
      error: () => {
        this.toasterService.error('Unable to load invoice preview');
      },
    });
  }

  ngOnDestroy(): void {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
    }
  }
}
